import { render, staticRenderFns } from "./InquiryShow.vue?vue&type=template&id=2b5646ba&"
import script from "./InquiryShow.vue?vue&type=script&lang=ts&"
export * from "./InquiryShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports